import * as React from "react";

interface ScrollContainerProps {
    children: React.ReactNode;
    direction: "-y" | "-x" | "x" | "y";
}

const ScrollContainer = ({ children, direction }: ScrollContainerProps) => {
    const isVertical = direction === "-y" || direction === "y";

    return (
        <div
            className={`scroll-container relative h-full ${
                isVertical ? "overflow-y-auto overflow-x-hidden" : "overflow-x-auto overflow-y-hidden"
            }`}
            style={{
                scrollbarWidth: "thin",
                scrollbarColor: "var(--color-brand) transparent",
            }}
        >
            {children}
        </div>
    );
};

export default ScrollContainer;
